/* eslint-disable */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from "axios";
import VueScrollTo from "vue-scrollto";
require('intersection-observer');
import VueObserveVisibility from 'vue-observe-visibility'
import Vue2TouchEvents from 'vue2-touch-events'

Vue.use(VueObserveVisibility) 
Vue.use(Vue2TouchEvents)
Vue.use(VueScrollTo)
Vue.config.productionTip = false


Vue.filter("yearformat", (value, formatString) => {
  var d = new Date(value * 1000);
  let format = {};
  if (formatString == 'Monat/Jahr') {
    format = { year: 'numeric', month: '2-digit'};
    return d.toLocaleDateString('de-DE', format);
  }
  if (formatString == 'Tag/Monat/Jahr') {
    format = { weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit'};
    return d.toLocaleDateString('de-DE', format);
  }
  if (formatString == 'Tag/Monat/Jahr HH:MM') {
    format = { weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', minute: 'numeric'};
    return d.toLocaleDateString('de-DE', format);
  }
  if (formatString == 'HH:MM') {
    format = { hour: 'numeric', minute: 'numeric'};    
    return d.toLocaleTimeString('de-DE', format);
  }
})

String.prototype.nl2br = function()
{
    return this.replace(/\n/g, "<br />");
}

const instance = axios.create({
  baseURL: window.location.hostname.match(/localhost|192.168|10.0/g) ? `http://${window.location.hostname}:8081/static/server/api` : '/static/server/api',
  //adapter: cacheAdapterEnhancer(axios.defaults.adapter)
});
instance.defaults.params = {}
instance.defaults.params['status'] = window.location.hostname.match(/localhost|192.168|10.0|preview/g) ? 'both' : 'published';
instance.defaults.params['flat']   = 'true';

var loading = {
  do: false,
  timeout: false
}

// before a request is made start the nprogress
instance.interceptors.request.use(config => {
  if (loading.timeout) {
    clearTimeout(loading.timeout);
    loading.timeout = false
  }
  loading.timeout = setTimeout(() => {
    loading.do = config.url.match(/font\.rokfor\.ch/) === null
  }, 500)
  return config
})

// before a response is returned stop nprogress
instance.interceptors.response.use(response => {
  if (loading.timeout) {
    clearTimeout(loading.timeout);
    loading.timeout = false
  }
  loading.do = false
  return response
})


var app = false;

// VH Calculation
var customViewportCorrectionVariable = 'vh';
function setViewportProperty(doc) {
  var prevClientHeight;
  var customVar = '--' + ( customViewportCorrectionVariable || 'vh' );
  function handleResize() {
    var clientHeight = doc.clientHeight;
    if (clientHeight === prevClientHeight) return;
    requestAnimationFrame(function updateViewportHeight(){
      if (clientHeight !== prevClientHeight) {
        doc.style.setProperty(customVar, (clientHeight * 0.01) + 'px');
      }
      prevClientHeight = clientHeight;
    });
  }
  handleResize();
  return handleResize;
}
window.addEventListener('resize', setViewportProperty(document.documentElement));


window.addEventListener('orientationchange', function(){
  console.log('orientation v.2');
  document.documentElement.style.height = `initial`;
  setTimeout(() => {
    document.documentElement.style.height = `100%`;
      setTimeout(() => {
        // this line prevents the content
        // from hiding behind the address bar
        window.scrollTo(0, 1);
        setViewportProperty(document.documentElement)
      }, 500);
  }, 500);
})


async function initialize() {
  let response = await instance.get('token');
  instance.defaults.headers.common["X-API-KEY"] =  response.data;
  setInterval(() => {
    instance.get('token').then((response) => {
      instance.defaults.headers.common["X-API-KEY"] =  response.data;
    });
  }, 60000);
  Vue.prototype.$http = instance;
  let _painterdata = await Vue.prototype.$http.get('painter');
  Vue.prototype.$painterdata = _painterdata.data;
  /* eslint-disable no-new */
  app = new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>',
    data() {
      let style = document.createElement('style');
      document.head.appendChild(style);
      return {
        sheet: style.sheet,
        latestFont: "",
        preloaded: false, // Preloaded Projects
        scrollOffset: false,
        overlayScrollPercentage: 0,
        overlayScrollY: 0,
        hitareaActive: false,
        overlayOpen: false,
        color: '',
        Menu: false,
        loading: loading,
        transitioning: false,
        isScrolling: false,
        baseNav: 'home'
      }
    },
    mounted() {
      this.$on('overlay:reachedtop', (back) => {
        if (back === true) {
          this.$router.go(-1);
        }
        else {
          this.$router.push({name: 'home'});
        }
      })
    },
    watch: {
      $route (to, from) {
          console.log(to) //
          this.overlayScrollPercentage = 0;
      }
    },
    methods: {
      checkTouchscreen() {
        return window.matchMedia("(pointer: coarse)").matches;
      },
      applyMeta(title, keywords, description, image) {
        image = image || '/static/images/logo.png';
        title = title || 'Kulturstiftung Thurgau';
        keywords = keywords || 'kulturstiftung thurgau kulturförderung';
        description = description || 'Die Kulturstiftung fördert und unterstützt professionelles zeitgenössisches Kulturschaffen mit Bezug zum Kanton Thurgau.';
        let identifier = 'data-meta-controlled';
        Array.from(document.querySelectorAll(`[${identifier}]`)).map(el => el.parentNode.removeChild(el));
        let _title = document.createElement('title');
        _title.setAttribute(identifier, '');
        _title.innerHTML = title;
        document.head.appendChild(_title);
        let _keywords = document.createElement('meta');
        _keywords.setAttribute('name', 'keywords');
        _keywords.setAttribute('content', keywords);
        _keywords.setAttribute(identifier, '');
        document.head.appendChild(_keywords);
        let _description = document.createElement('meta');
        _description.setAttribute('name', 'description');
        _description.setAttribute('content', description);
        _description.setAttribute(identifier, '');
        document.head.appendChild(_description);


        let _ogdescription = document.createElement('meta');
        _ogdescription.setAttribute('property', 'og:description');
        _ogdescription.setAttribute('content', description);
        _ogdescription.setAttribute(identifier, '');
        document.head.appendChild(_ogdescription);

        let _ogtitle = document.createElement('meta');
        _ogtitle.setAttribute('property', 'og:title');
        _ogtitle.setAttribute('content', title);
        _ogtitle.setAttribute(identifier, '');
        document.head.appendChild(_ogtitle);

        if (image) {
          let _ogimage = document.createElement('meta');
          _ogimage.setAttribute('property', 'og:image');
          _ogimage.setAttribute('content', image);
          _ogimage.setAttribute(identifier, '');
          document.head.appendChild(_ogimage);
        }
    










      },
      measure(e, tg, back) {
        back = back || false;
        let offset = tg && tg.classList.contains('ks-overlay-container-top') ? 0 : document.documentElement.clientHeight;
        this.overlayScrollY = offset  - e.target.scrollTop;
        this.overlayScrollPercentage = 100 / (e.target.scrollHeight - e.target.clientHeight * 1.5) * (e.target.scrollTop - (e.target.clientHeight / 2));
        this.overlayScrollPercentage = this.overlayScrollPercentage < 0 ? 0 : this.overlayScrollPercentage
        if (this.overlayScrollY == document.documentElement.clientHeight && document.documentElement.clientHeight > 0) {
          console.log(this.overlayScrollY, document.documentElement.clientHeight, offset, e.target.scrollTop)
          this.$emit('overlay:reachedtop', back);
        }
        else {
          this.$emit('overlay:scroll', this.overlayScrollY);
        }
        this.isScrolling = true
        setTimeout(()=>{
          this.isScrolling = false
        }, 5000)
      }
    }
  })
  app.$mount('#app')
}
  

initialize();














































// WEBPACK FOOTER //
// ./src/main.js